"use strict";

class Nav {
  constructor() {
    this.nav = Array.prototype.slice.call( document.querySelector( ".nav-list" ).children );
    this.navSlider = Array.prototype.slice.call( document.querySelectorAll( ".nav-slide-bar" ) );

    this.raf;
    this.active = document.querySelector( ".nav-active" );

    this.body = document.querySelector('body');
    this.navButton = document.querySelector('label');

    this.events();
  }

  events() {
    if( this.active ) { 
      window.addEventListener( 'load', this.rafResize.bind(this) );
      window.addEventListener( 'resize', this.rafResize.bind(this), false );
    }
    
    this.nav.forEach( item => {
      item.addEventListener( 'mouseover', this.slideBar.bind(this) );
      if( this.active ) {
        item.addEventListener( 'mouseout', this.moveToActive.bind(this) );
      } else {
        item.addEventListener( 'mouseout', this.removeBar.bind(this) );
      }
    });
  }

  // methods

  rafResize() {
    if( this.raf ) {
      window.cancelAnimationFrame( this.raf );
    }

    this.raf = window.requestAnimationFrame( this.moveToActive.bind(this));
  }

  slideBar( e ) {
    this.navSlider.forEach( item => {
      let left = e.target.getBoundingClientRect().left;
      
      item.style.opacity = 1;
      item.style.left = `${left}px`;
      item.style.width = `${e.target.offsetWidth}px`;
    });
    
  }
  
  moveToActive( e ) {
    this.navSlider.forEach( item => { 
      if( this.active.offsetWidth < 200 ) {
        item.style.opacity = 1;
        item.style.left = `${ this.active.offsetLeft }px`;
        item.style.width = `${ this.active.offsetWidth }px`;
      }
    });
  }
  
  removeBar() {
    this.navSlider.forEach( item => {
      item.style.opacity = 0;
    });
  }
}

export default Nav;